// extracted by mini-css-extract-plugin
module.exports = {"assistenzaButton":"AssistenzaButton_assistenzaButton__9dlYD","icon":"AssistenzaButton_icon__Fe1KX","label":"AssistenzaButton_label__nD_W_","arrow":"AssistenzaButton_arrow___i5LQ"};